let $middleGreen = '#57ae67'
let $selectTriggerBtn = {
  'border' : '1px solid #bcd5ef',
  'color' : $middleGreen,
  'padding' : '0 10px'
}

  export default {
'selectTriggerBtn' : { 

 typeTheme :{ 
 'bankSelect' : { 
  ...$selectTriggerBtn,
  'line-height' : '40px',
  'background-color' : 'white',
  'width' : '85%',
  'height' : '60px',
  'margin' : '0 auto',
  'text-align' : 'center'
 
}} 
}

}